define('TavanoTeam.DoubleUnitSales.Request.View'
,	[
		'tavanoteam_request.tpl'
	,	'Utils'
    ,	'Backbone'
	,   'Backbone.FormView'
	,	'Backbone.CompositeView'
	,	'TavanoTeam.DoubleUnitSales.Model'
	,	'TavanoTeam.DoubleUnitSales.Confirmation.View'
	,	'jQuery'
	,	'underscore'
	]
,	function (
        tavanoteam_request_tpl
	,	Utils
    ,	Backbone
	,   BackboneFormView
	,	BackboneCompositeView
	,	DoubleUnitSalesModel
	,	DoubleUnitSalesConfirmationView
	,	jQuery
	,	_
	)
{
	'use strict';

	return Backbone.View.extend({

		template: tavanoteam_request_tpl,
		bindings: {
			'[name="quantity"]': 'quantity'
			,	'[name="zip"]': 'zip'
			,	'[name="email"]': 'email'
		},
		events: {
			'submit form': 'saveForm'
		},
		initialize: function (options) {			
            BackboneCompositeView.add(this);
            this.model = new DoubleUnitSalesModel();
			BackboneFormView.add(this); 
			this.model.on('sync', jQuery.proxy(this, 'manageResponse'));
		},

		manageResponse : function manageResponse(model) {
			if (model.get("status") == "fail"){
				this.showError();
			}else{
				this.showSuccess();
			}
		},
		showSuccess : function showSuccess() {
            var layout = this.options.layout;
			var confirmationView = new DoubleUnitSalesConfirmationView({isConfirmation:  true});
			layout.showInModal(confirmationView,{});
		},
		showError : function showError() {
            var layout = this.options.layout;
			var confirmationView = new DoubleUnitSalesConfirmationView({isConfirmation:  false});
			layout.showInModal(confirmationView,{});
		},

		getContext: function getContext()
		{
			return{
				item: this.options.item.internalid,
				itemid: this.options.item.itemid
			}
		}
    }) 
});
